import { render } from "./BarraLateral.vue?vue&type=template&id=2afb821e&scoped=true"
import script from "./BarraLateral.vue?vue&type=script&lang=js"
export * from "./BarraLateral.vue?vue&type=script&lang=js"

import "./BarraLateral.vue?vue&type=style&index=0&id=2afb821e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afb821e"]])

export default __exports__